// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1O746","actionsCol":"EnrolledClinics_actionsCol__eUepv"};